module.exports = __webpack_public_path__ + "assets/img/245b5d202e6d61526d0406774f3c2ec6.svg";